export const LOGIN = 'login';
export const ADD_VALUE_TO_SEARCH_FILTER ='addvaluetosearchfilter';
export const REMOVE_FILTER ='removefilter';
export const COUNTRIES_MARKERS = 'countries_markers';
export const CLEAR_FILTER = 'clearfilter';
export const LOGOUT = 'logout';
export const TOGGLE_SIDEBAR = 'toggle_sidebar';
export const ON_RESOURCE_CHANGE = 'on_resource_change'